module.exports = __webpack_public_path__ + "img/semioad-original-960.1cd1138f.webp";